import app from 'flarum/forum/app';
import addCommunityControls from './communityControls';
export { default as extend } from './extend';
app.initializers.add('devconnect-community', () => {
  addCommunityControls();
});